export default [
  {
    "name": "alphamaps",
    "data": {},
    "items": [
      {
        "name": "alphamaps_alpha_001_png",
        "source": "/alphamaps/alpha-001.png",
        "type": "image"
      },
      {
        "name": "alphamaps_alpha_002_png",
        "source": "/alphamaps/alpha-002.png",
        "type": "image"
      },
      {
        "name": "alphamaps_alpha_003_png",
        "source": "/alphamaps/alpha-003.png",
        "type": "image"
      }
    ]
  },
  {
    "name": "cubes",
    "data": {},
    "items": [
      {
        "name": "cubes_cube001_nx_png",
        "source": "/cubes/cube001/nx.png",
        "type": "image"
      },
      {
        "name": "cubes_cube001_ny_png",
        "source": "/cubes/cube001/ny.png",
        "type": "image"
      },
      {
        "name": "cubes_cube001_nz_png",
        "source": "/cubes/cube001/nz.png",
        "type": "image"
      },
      {
        "name": "cubes_cube001_px_png",
        "source": "/cubes/cube001/px.png",
        "type": "image"
      },
      {
        "name": "cubes_cube001_py_png",
        "source": "/cubes/cube001/py.png",
        "type": "image"
      },
      {
        "name": "cubes_cube001_pz_png",
        "source": "/cubes/cube001/pz.png",
        "type": "image"
      },
      {
        "name": "cubes_cube002_nx_png",
        "source": "/cubes/cube002/nx.png",
        "type": "image"
      },
      {
        "name": "cubes_cube002_ny_png",
        "source": "/cubes/cube002/ny.png",
        "type": "image"
      },
      {
        "name": "cubes_cube002_nz_png",
        "source": "/cubes/cube002/nz.png",
        "type": "image"
      },
      {
        "name": "cubes_cube002_px_png",
        "source": "/cubes/cube002/px.png",
        "type": "image"
      },
      {
        "name": "cubes_cube002_py_png",
        "source": "/cubes/cube002/py.png",
        "type": "image"
      },
      {
        "name": "cubes_cube002_pz_png",
        "source": "/cubes/cube002/pz.png",
        "type": "image"
      },
      {
        "name": "cubes_cube003_nx_png",
        "source": "/cubes/cube003/nx.png",
        "type": "image"
      },
      {
        "name": "cubes_cube003_ny_png",
        "source": "/cubes/cube003/ny.png",
        "type": "image"
      },
      {
        "name": "cubes_cube003_nz_png",
        "source": "/cubes/cube003/nz.png",
        "type": "image"
      },
      {
        "name": "cubes_cube003_px_png",
        "source": "/cubes/cube003/px.png",
        "type": "image"
      },
      {
        "name": "cubes_cube003_py_png",
        "source": "/cubes/cube003/py.png",
        "type": "image"
      },
      {
        "name": "cubes_cube003_pz_png",
        "source": "/cubes/cube003/pz.png",
        "type": "image"
      },
      {
        "name": "cubes_cube004_nx_png",
        "source": "/cubes/cube004/nx.png",
        "type": "image"
      },
      {
        "name": "cubes_cube004_ny_png",
        "source": "/cubes/cube004/ny.png",
        "type": "image"
      },
      {
        "name": "cubes_cube004_nz_png",
        "source": "/cubes/cube004/nz.png",
        "type": "image"
      },
      {
        "name": "cubes_cube004_px_png",
        "source": "/cubes/cube004/px.png",
        "type": "image"
      },
      {
        "name": "cubes_cube004_py_png",
        "source": "/cubes/cube004/py.png",
        "type": "image"
      },
      {
        "name": "cubes_cube004_pz_png",
        "source": "/cubes/cube004/pz.png",
        "type": "image"
      },
      {
        "name": "cubes_cube005_nx_png",
        "source": "/cubes/cube005/nx.png",
        "type": "image"
      },
      {
        "name": "cubes_cube005_ny_png",
        "source": "/cubes/cube005/ny.png",
        "type": "image"
      },
      {
        "name": "cubes_cube005_nz_png",
        "source": "/cubes/cube005/nz.png",
        "type": "image"
      },
      {
        "name": "cubes_cube005_px_png",
        "source": "/cubes/cube005/px.png",
        "type": "image"
      },
      {
        "name": "cubes_cube005_py_png",
        "source": "/cubes/cube005/py.png",
        "type": "image"
      },
      {
        "name": "cubes_cube005_pz_png",
        "source": "/cubes/cube005/pz.png",
        "type": "image"
      },
      {
        "name": "cubes_cube006_nx_png",
        "source": "/cubes/cube006/nx.png",
        "type": "image"
      },
      {
        "name": "cubes_cube006_ny_png",
        "source": "/cubes/cube006/ny.png",
        "type": "image"
      },
      {
        "name": "cubes_cube006_nz_png",
        "source": "/cubes/cube006/nz.png",
        "type": "image"
      },
      {
        "name": "cubes_cube006_px_png",
        "source": "/cubes/cube006/px.png",
        "type": "image"
      },
      {
        "name": "cubes_cube006_py_png",
        "source": "/cubes/cube006/py.png",
        "type": "image"
      },
      {
        "name": "cubes_cube006_pz_png",
        "source": "/cubes/cube006/pz.png",
        "type": "image"
      },
      {
        "name": "cubes_cube007_nx_png",
        "source": "/cubes/cube007/nx.png",
        "type": "image"
      },
      {
        "name": "cubes_cube007_ny_png",
        "source": "/cubes/cube007/ny.png",
        "type": "image"
      },
      {
        "name": "cubes_cube007_nz_png",
        "source": "/cubes/cube007/nz.png",
        "type": "image"
      },
      {
        "name": "cubes_cube007_px_png",
        "source": "/cubes/cube007/px.png",
        "type": "image"
      },
      {
        "name": "cubes_cube007_py_png",
        "source": "/cubes/cube007/py.png",
        "type": "image"
      },
      {
        "name": "cubes_cube007_pz_png",
        "source": "/cubes/cube007/pz.png",
        "type": "image"
      },
      {
        "name": "cubes_cube008_nx_png",
        "source": "/cubes/cube008/nx.png",
        "type": "image"
      },
      {
        "name": "cubes_cube008_ny_png",
        "source": "/cubes/cube008/ny.png",
        "type": "image"
      },
      {
        "name": "cubes_cube008_nz_png",
        "source": "/cubes/cube008/nz.png",
        "type": "image"
      },
      {
        "name": "cubes_cube008_px_png",
        "source": "/cubes/cube008/px.png",
        "type": "image"
      },
      {
        "name": "cubes_cube008_py_png",
        "source": "/cubes/cube008/py.png",
        "type": "image"
      },
      {
        "name": "cubes_cube008_pz_png",
        "source": "/cubes/cube008/pz.png",
        "type": "image"
      }
    ]
  },
  {
    "name": "cursor",
    "data": {},
    "items": [
      {
        "name": "cursor_01_01_svg",
        "source": "/cursor/01/01.svg",
        "type": "svg"
      },
      {
        "name": "cursor_icons_c01_svg",
        "source": "/cursor/icons/c01.svg",
        "type": "svg"
      },
      {
        "name": "cursor_icons_c02_svg",
        "source": "/cursor/icons/c02.svg",
        "type": "svg"
      },
      {
        "name": "cursor_icons_c03_svg",
        "source": "/cursor/icons/c03.svg",
        "type": "svg"
      },
      {
        "name": "cursor_icons_c04_svg",
        "source": "/cursor/icons/c04.svg",
        "type": "svg"
      },
      {
        "name": "cursor_icons_c05_svg",
        "source": "/cursor/icons/c05.svg",
        "type": "svg"
      },
      {
        "name": "cursor_icons_c06_svg",
        "source": "/cursor/icons/c06.svg",
        "type": "svg"
      },
      {
        "name": "cursor_icons_c4_svg",
        "source": "/cursor/icons/c4.svg",
        "type": "svg"
      },
      {
        "name": "cursor_icons_i01_svg",
        "source": "/cursor/icons/i01.svg",
        "type": "svg"
      },
      {
        "name": "cursor_icons_i02_svg",
        "source": "/cursor/icons/i02.svg",
        "type": "svg"
      },
      {
        "name": "cursor_icons_i03_svg",
        "source": "/cursor/icons/i03.svg",
        "type": "svg"
      },
      {
        "name": "cursor_icons_i04_svg",
        "source": "/cursor/icons/i04.svg",
        "type": "svg"
      },
      {
        "name": "cursor_icons_i05_svg",
        "source": "/cursor/icons/i05.svg",
        "type": "svg"
      },
      {
        "name": "cursor_icons_i06_svg",
        "source": "/cursor/icons/i06.svg",
        "type": "svg"
      },
      {
        "name": "cursor_icons_i07_svg",
        "source": "/cursor/icons/i07.svg",
        "type": "svg"
      },
      {
        "name": "cursor_logo_svg",
        "source": "/cursor/logo.svg",
        "type": "svg"
      }
    ]
  },
  {
    "name": "draco",
    "data": {},
    "items": [
      {
        "name": "draco_gltf_draco_decoder_js",
        "source": "/draco/gltf/draco_decoder.js",
        "type": "asset"
      },
      {
        "name": "draco_gltf_draco_decoder_wasm",
        "source": "/draco/gltf/draco_decoder.wasm",
        "type": "asset"
      }
    ]
  },
  {
    "name": "envs",
    "data": {},
    "items": [
      {
        "name": "envs_blaubeuren_night_2k_hdr",
        "source": "/envs/blaubeuren_night_2k.hdr",
        "type": "hdr"
      },
      {
        "name": "envs_creepy_bathroom_2k_hdr",
        "source": "/envs/creepy_bathroom_2k.hdr",
        "type": "hdr"
      },
      {
        "name": "envs_env_club_1k_hdr",
        "source": "/envs/env_club_1k.hdr",
        "type": "hdr"
      },
      {
        "name": "envs_era_7_hdr",
        "source": "/envs/era-7.hdr",
        "type": "hdr"
      },
      {
        "name": "envs_kloppenheim_02_2k_hdr",
        "source": "/envs/kloppenheim_02_2k.hdr",
        "type": "hdr"
      },
      {
        "name": "envs_mayoris_hdr",
        "source": "/envs/mayoris.hdr",
        "type": "hdr"
      },
      {
        "name": "envs_misty_farm_road_2k_hdr",
        "source": "/envs/misty_farm_road_2k.hdr",
        "type": "hdr"
      },
      {
        "name": "envs_moonless_golf_2k_hdr",
        "source": "/envs/moonless_golf_2k.hdr",
        "type": "hdr"
      },
      {
        "name": "envs_night_bridge_2k_hdr",
        "source": "/envs/night_bridge_2k.hdr",
        "type": "hdr"
      },
      {
        "name": "envs_night2k_hdr",
        "source": "/envs/night2k.hdr",
        "type": "hdr"
      },
      {
        "name": "envs_OMEGA_hdr",
        "source": "/envs/OMEGA.hdr",
        "type": "hdr"
      },
      {
        "name": "envs_overcast_soil_puresky_2k_hdr",
        "source": "/envs/overcast_soil_puresky_2k.hdr",
        "type": "hdr"
      },
      {
        "name": "envs_shanghai_bund_2k_hdr",
        "source": "/envs/shanghai_bund_2k.hdr",
        "type": "hdr"
      },
      {
        "name": "envs_softbox_hdr",
        "source": "/envs/softbox.hdr",
        "type": "hdr"
      }
    ]
  },
  {
    "name": "fonts",
    "data": {},
    "items": [
      {
        "name": "fonts_flowa_woff2",
        "source": "/fonts/flowa.woff2",
        "type": "font"
      },
      {
        "name": "fonts_Henke_woff2",
        "source": "/fonts/Henke.woff2",
        "type": "font"
      },
      {
        "name": "fonts_Pilowlava_Atome_woff2",
        "source": "/fonts/Pilowlava-Atome.woff2",
        "type": "font"
      },
      {
        "name": "fonts_Pilowlava_Regular_woff2",
        "source": "/fonts/Pilowlava-Regular.woff2",
        "type": "font"
      },
      {
        "name": "fonts_pirulen_woff2",
        "source": "/fonts/pirulen.woff2",
        "type": "font"
      },
      {
        "name": "fonts_Roboto_Bold_woff2",
        "source": "/fonts/Roboto-Bold.woff2",
        "type": "font"
      },
      {
        "name": "fonts_Roboto_Medium_woff2",
        "source": "/fonts/Roboto-Medium.woff2",
        "type": "font"
      },
      {
        "name": "fonts_Roboto_Regular_woff2",
        "source": "/fonts/Roboto-Regular.woff2",
        "type": "font"
      },
      {
        "name": "fonts_Roboto_Thin_woff2",
        "source": "/fonts/Roboto-Thin.woff2",
        "type": "font"
      }
    ]
  },
  {
    "name": "icons",
    "data": {},
    "items": [
      {
        "name": "icons_appIcon_1024_1x_png",
        "source": "/icons/appIcon-1024@1x.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_20_1x_png",
        "source": "/icons/appIcon-20@1x.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_20_2x_png",
        "source": "/icons/appIcon-20@2x.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_20_3x_png",
        "source": "/icons/appIcon-20@3x.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_29_1x_png",
        "source": "/icons/appIcon-29@1x.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_29_2x_png",
        "source": "/icons/appIcon-29@2x.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_29_3x_png",
        "source": "/icons/appIcon-29@3x.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_40_1x_png",
        "source": "/icons/appIcon-40@1x.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_40_2x_png",
        "source": "/icons/appIcon-40@2x.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_40_3x_png",
        "source": "/icons/appIcon-40@3x.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_60_2x_png",
        "source": "/icons/appIcon-60@2x.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_60_3x_png",
        "source": "/icons/appIcon-60@3x.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_76_1x_png",
        "source": "/icons/appIcon-76@1x.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_76_2x_png",
        "source": "/icons/appIcon-76@2x.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_83_5_2x_png",
        "source": "/icons/appIcon-83.5@2x.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_vector_svg",
        "source": "/icons/appIcon-vector.svg",
        "type": "svg"
      },
      {
        "name": "icons_appIcon_png",
        "source": "/icons/appIcon.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_2x_png",
        "source": "/icons/appIcon@2x.png",
        "type": "image"
      },
      {
        "name": "icons_appIcon_3x_png",
        "source": "/icons/appIcon@3x.png",
        "type": "image"
      }
    ]
  },
  {
    "name": "luts",
    "data": {},
    "items": [
      {
        "name": "luts_LUT_BleachBypass_png",
        "source": "/luts/LUT_BleachBypass.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_CandleLight_png",
        "source": "/luts/LUT_CandleLight.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_CoolContrast_png",
        "source": "/luts/LUT_CoolContrast.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_DesaturatedFog_png",
        "source": "/luts/LUT_DesaturatedFog.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_Evening_png",
        "source": "/luts/LUT_Evening.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_Fall_png",
        "source": "/luts/LUT_Fall.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_Filmic_png",
        "source": "/luts/LUT_Filmic.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_Filmic2_png",
        "source": "/luts/LUT_Filmic2.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_Filmic3_png",
        "source": "/luts/LUT_Filmic3.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_Filmic4_png",
        "source": "/luts/LUT_Filmic4.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_Filmic5_png",
        "source": "/luts/LUT_Filmic5.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_Filmic6_png",
        "source": "/luts/LUT_Filmic6.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_Filmic7_png",
        "source": "/luts/LUT_Filmic7.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_Filmic8_png",
        "source": "/luts/LUT_Filmic8.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_Filmic9_png",
        "source": "/luts/LUT_Filmic9.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_MatrixBlue_png",
        "source": "/luts/LUT_MatrixBlue.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_MatrixGreen_png",
        "source": "/luts/LUT_MatrixGreen.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_Night_Dark_png",
        "source": "/luts/LUT_Night_Dark.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_Night1_png",
        "source": "/luts/LUT_Night1.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_Night2_png",
        "source": "/luts/LUT_Night2.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_StrongAmber_png",
        "source": "/luts/LUT_StrongAmber.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_Warm_png",
        "source": "/luts/LUT_Warm.png",
        "type": "image"
      },
      {
        "name": "luts_LUT_WarmContrast_png",
        "source": "/luts/LUT_WarmContrast.png",
        "type": "image"
      }
    ]
  },
  {
    "name": "models",
    "data": {},
    "items": [
      {
        "name": "models_gitkeep",
        "source": "/models/.gitkeep",
        "type": "asset"
      },
      {
        "name": "models_fbx_68899602daec38bbc8a8792f2425f8da_rigged_fbx",
        "source": "/models/fbx/68899602daec38bbc8a8792f2425f8da_rigged.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_alien_fbx",
        "source": "/models/fbx/alien.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_curiousKid_animations_idle02_fbx",
        "source": "/models/fbx/curiousKid/animations/idle02.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_curiousKid_animations_Low_Crawl_fbx",
        "source": "/models/fbx/curiousKid/animations/Low Crawl.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_curiousKid_animations_Petting_fbx",
        "source": "/models/fbx/curiousKid/animations/Petting.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_curiousKid_animations_petting1_fbx",
        "source": "/models/fbx/curiousKid/animations/petting1.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_curiousKid_animations_petting2_fbx",
        "source": "/models/fbx/curiousKid/animations/petting2.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_curiousKid_animations_player_happyIdle_fbx",
        "source": "/models/fbx/curiousKid/animations/player@happyIdle.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_curiousKid_animations_player_neutralIdle_fbx",
        "source": "/models/fbx/curiousKid/animations/player@neutralIdle.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_curiousKid_animations_player_offensiveIdle_fbx",
        "source": "/models/fbx/curiousKid/animations/player@offensiveIdle.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_curiousKid_animations_player_running_fbx",
        "source": "/models/fbx/curiousKid/animations/player@running.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_curiousKid_animations_player_running2_fbx",
        "source": "/models/fbx/curiousKid/animations/player@running2.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_curiousKid_animations_player_standardWalk_fbx",
        "source": "/models/fbx/curiousKid/animations/player@standardWalk.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_curiousKid_animations_player_twearking_glb",
        "source": "/models/fbx/curiousKid/animations/player@twearking.glb",
        "type": "model"
      },
      {
        "name": "models_fbx_curiousKid_animations_player_walking_fbx",
        "source": "/models/fbx/curiousKid/animations/player@walking.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_curiousKid_animations_sitting1_fbx",
        "source": "/models/fbx/curiousKid/animations/sitting1.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_curiousKid_animations_Walking_fbx",
        "source": "/models/fbx/curiousKid/animations/Walking.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_curiousKid_license_Description_txt",
        "source": "/models/fbx/curiousKid/license/Description.txt",
        "type": "asset"
      },
      {
        "name": "models_fbx_curiousKid_license_User_Guide_pdf",
        "source": "/models/fbx/curiousKid/license/User Guide.pdf",
        "type": "asset"
      },
      {
        "name": "models_fbx_curiousKid_license_vk0114_Preview_jpg",
        "source": "/models/fbx/curiousKid/license/vk0114_Preview.jpg",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_license_vk0114_Thumbnail_jpg",
        "source": "/models/fbx/curiousKid/license/vk0114_Thumbnail.jpg",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin000_map_png",
        "source": "/models/fbx/curiousKid/skins/skin000/map.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin000_metalnessMap_png",
        "source": "/models/fbx/curiousKid/skins/skin000/metalnessMap.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin001_map_png",
        "source": "/models/fbx/curiousKid/skins/skin001/map.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin001_metalnessMap_png",
        "source": "/models/fbx/curiousKid/skins/skin001/metalnessMap.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin001_opacity_jpg",
        "source": "/models/fbx/curiousKid/skins/skin001/opacity.jpg",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin001_roughnessMap_png",
        "source": "/models/fbx/curiousKid/skins/skin001/roughnessMap.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin001_translucence_png",
        "source": "/models/fbx/curiousKid/skins/skin001/translucence.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin002_map_png",
        "source": "/models/fbx/curiousKid/skins/skin002/map.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin002_metalnessMap_png",
        "source": "/models/fbx/curiousKid/skins/skin002/metalnessMap.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin002_roughnessMap_png",
        "source": "/models/fbx/curiousKid/skins/skin002/roughnessMap.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin003_map_png",
        "source": "/models/fbx/curiousKid/skins/skin003/map.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin003_metalnessMap_png",
        "source": "/models/fbx/curiousKid/skins/skin003/metalnessMap.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin003_roughnessMap_png",
        "source": "/models/fbx/curiousKid/skins/skin003/roughnessMap.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin003_translucence_png",
        "source": "/models/fbx/curiousKid/skins/skin003/translucence.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin004_aomap_png",
        "source": "/models/fbx/curiousKid/skins/skin004/aomap.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin004_dismap_png",
        "source": "/models/fbx/curiousKid/skins/skin004/dismap.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin004_map_png",
        "source": "/models/fbx/curiousKid/skins/skin004/map.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin004_map02_png",
        "source": "/models/fbx/curiousKid/skins/skin004/map02.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin004_NormalMap_png",
        "source": "/models/fbx/curiousKid/skins/skin004/NormalMap.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin004_roughness_png",
        "source": "/models/fbx/curiousKid/skins/skin004/roughness.png",
        "type": "image"
      },
      {
        "name": "models_fbx_curiousKid_skins_skin004_SpecularMap_png",
        "source": "/models/fbx/curiousKid/skins/skin004/SpecularMap.png",
        "type": "image"
      },
      {
        "name": "models_fbx_dashed_torus_fbx",
        "source": "/models/fbx/dashed_torus.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_piya_animations_Thankful_fbx",
        "source": "/models/fbx/piya/animations/Thankful.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_piya_animations_Walking_fbx",
        "source": "/models/fbx/piya/animations/Walking.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_piya_PIYA_fbx",
        "source": "/models/fbx/piya/PIYA.fbx",
        "type": "model"
      },
      {
        "name": "models_fbx_raven_fbx",
        "source": "/models/fbx/raven.fbx",
        "type": "model"
      },
      {
        "name": "models_glb_eye_glb",
        "source": "/models/glb/eye.glb",
        "type": "model"
      },
      {
        "name": "models_glb_flow_cFlow_glb",
        "source": "/models/glb/flow/cFlow.glb",
        "type": "model"
      },
      {
        "name": "models_glb_flow_gltf_cFlow_bin",
        "source": "/models/glb/flow/gltf/cFlow.bin",
        "type": "asset"
      },
      {
        "name": "models_glb_flow_gltf_cFlow_gltf",
        "source": "/models/glb/flow/gltf/cFlow.gltf",
        "type": "model"
      },
      {
        "name": "models_glb_flow4_cFlow4_glb",
        "source": "/models/glb/flow4/cFlow4.glb",
        "type": "model"
      },
      {
        "name": "models_glb_platform_gltf_icon_Anja_images_composited_baseColor_opacity_png",
        "source": "/models/glb/platform/gltf/icon-Anja_images/composited_baseColor_opacity.png",
        "type": "image"
      },
      {
        "name": "models_glb_platform_gltf_icon_Anja_images_composited_roughness_png",
        "source": "/models/glb/platform/gltf/icon-Anja_images/composited_roughness.png",
        "type": "image"
      },
      {
        "name": "models_glb_platform_gltf_platform_bin",
        "source": "/models/glb/platform/gltf/platform.bin",
        "type": "asset"
      },
      {
        "name": "models_glb_platform_gltf_platform_gltf",
        "source": "/models/glb/platform/gltf/platform.gltf",
        "type": "model"
      },
      {
        "name": "models_glb_platform_plat_skins_001_platform_baseColor_png",
        "source": "/models/glb/platform/plat-skins/001/platform_baseColor.png",
        "type": "image"
      },
      {
        "name": "models_glb_platform_plat_skins_001_platform_metallic_png",
        "source": "/models/glb/platform/plat-skins/001/platform_metallic.png",
        "type": "image"
      },
      {
        "name": "models_glb_platform_plat_skins_001_platform_opacity_png",
        "source": "/models/glb/platform/plat-skins/001/platform_opacity.png",
        "type": "image"
      },
      {
        "name": "models_glb_platform_plat_skins_001_platform_roughness_png",
        "source": "/models/glb/platform/plat-skins/001/platform_roughness.png",
        "type": "image"
      },
      {
        "name": "models_glb_platform_plat_skins_001_platform_translucence_png",
        "source": "/models/glb/platform/plat-skins/001/platform_translucence.png",
        "type": "image"
      },
      {
        "name": "models_glb_theAllies_glb",
        "source": "/models/glb/theAllies.glb",
        "type": "model"
      }
    ]
  },
  {
    "name": "music",
    "data": {},
    "items": [
      {
        "name": "music_Do_mp3",
        "source": "/music/Do.mp3",
        "type": "audio"
      },
      {
        "name": "music_i_keep_on_walking_mp3",
        "source": "/music/i_keep_on_walking.mp3",
        "type": "audio"
      },
      {
        "name": "music_lucid_space_ogg",
        "source": "/music/lucid_space.ogg",
        "type": "audio"
      },
      {
        "name": "music_noches_de_samba_wav",
        "source": "/music/noches_de_samba.wav",
        "type": "audio"
      },
      {
        "name": "music_playlist_json",
        "source": "/music/playlist.json",
        "type": "json"
      },
      {
        "name": "music_spin_around_wav",
        "source": "/music/spin_around.wav",
        "type": "audio"
      }
    ]
  },
  {
    "name": "particles",
    "data": {},
    "items": [
      {
        "name": "particles_p_001_png",
        "source": "/particles/p_001.png",
        "type": "image"
      },
      {
        "name": "particles_p_002_png",
        "source": "/particles/p_002.png",
        "type": "image"
      },
      {
        "name": "particles_p_003_png",
        "source": "/particles/p_003.png",
        "type": "image"
      },
      {
        "name": "particles_p_004_png",
        "source": "/particles/p_004.png",
        "type": "image"
      },
      {
        "name": "particles_p_005_png",
        "source": "/particles/p_005.png",
        "type": "image"
      },
      {
        "name": "particles_p_006_png",
        "source": "/particles/p_006.png",
        "type": "image"
      },
      {
        "name": "particles_p_007_png",
        "source": "/particles/p_007.png",
        "type": "image"
      },
      {
        "name": "particles_p_008_png",
        "source": "/particles/p_008.png",
        "type": "image"
      },
      {
        "name": "particles_p_009_png",
        "source": "/particles/p_009.png",
        "type": "image"
      },
      {
        "name": "particles_p_010_png",
        "source": "/particles/p_010.png",
        "type": "image"
      },
      {
        "name": "particles_p_011_png",
        "source": "/particles/p_011.png",
        "type": "image"
      },
      {
        "name": "particles_p_012_png",
        "source": "/particles/p_012.png",
        "type": "image"
      },
      {
        "name": "particles_p_013_png",
        "source": "/particles/p_013.png",
        "type": "image"
      },
      {
        "name": "particles_p_014_png",
        "source": "/particles/p_014.png",
        "type": "image"
      },
      {
        "name": "particles_p_015_png",
        "source": "/particles/p_015.png",
        "type": "image"
      }
    ]
  },
  {
    "name": "root",
    "data": {},
    "items": [
      {
        "name": "apple_touch_icon_png",
        "source": "/apple-touch-icon.png",
        "type": "image"
      },
      {
        "name": "favicon_svg",
        "source": "/favicon.svg",
        "type": "svg"
      },
      {
        "name": "icon_192_png",
        "source": "/icon-192.png",
        "type": "image"
      },
      {
        "name": "icon_512_png",
        "source": "/icon-512.png",
        "type": "image"
      },
      {
        "name": "logo_svg",
        "source": "/logo.svg",
        "type": "svg"
      },
      {
        "name": "materials_json",
        "source": "/materials.json",
        "type": "json"
      },
      {
        "name": "particleAtlas_json",
        "source": "/particleAtlas.json",
        "type": "json"
      },
      {
        "name": "particleAtlas_webp",
        "source": "/particleAtlas.webp",
        "type": "image"
      },
      {
        "name": "site_webmanifest",
        "source": "/site.webmanifest",
        "type": "asset"
      },
      {
        "name": "textureAtlas_json",
        "source": "/textureAtlas.json",
        "type": "json"
      },
      {
        "name": "textureAtlas_webp",
        "source": "/textureAtlas.webp",
        "type": "image"
      }
    ]
  },
  {
    "name": "sounds",
    "data": {},
    "items": [
      {
        "name": "sounds_344_audio_344_Audio_EULA_pdf",
        "source": "/sounds/344_audio/344 Audio - EULA.pdf",
        "type": "asset"
      },
      {
        "name": "sounds_344_audio_Lo_Fi_Rumble_mp3",
        "source": "/sounds/344_audio/Lo-Fi_Rumble.mp3",
        "type": "audio"
      },
      {
        "name": "sounds_344_audio_Lo_Fi_Rumble_ogg",
        "source": "/sounds/344_audio/Lo-Fi_Rumble.ogg",
        "type": "audio"
      }
    ]
  },
  {
    "name": "svg",
    "data": {},
    "items": [
      {
        "name": "svg_ai_btn_svg",
        "source": "/svg/ai-btn.svg",
        "type": "svg"
      },
      {
        "name": "svg_codepen_btn_svg",
        "source": "/svg/codepen-btn.svg",
        "type": "svg"
      },
      {
        "name": "svg_data_btn_svg",
        "source": "/svg/data-btn.svg",
        "type": "svg"
      },
      {
        "name": "svg_db_btn_svg",
        "source": "/svg/db-btn.svg",
        "type": "svg"
      },
      {
        "name": "svg_debug_btn_svg",
        "source": "/svg/debug-btn.svg",
        "type": "svg"
      },
      {
        "name": "svg_github_btn_svg",
        "source": "/svg/github-btn.svg",
        "type": "svg"
      },
      {
        "name": "svg_icon_scene_is_01_svg",
        "source": "/svg/icon-scene/is-01.svg",
        "type": "svg"
      },
      {
        "name": "svg_icon_scene_is_02_svg",
        "source": "/svg/icon-scene/is-02.svg",
        "type": "svg"
      },
      {
        "name": "svg_icon_scene_is_03_svg",
        "source": "/svg/icon-scene/is-03.svg",
        "type": "svg"
      },
      {
        "name": "svg_icon_scene_is_04_svg",
        "source": "/svg/icon-scene/is-04.svg",
        "type": "svg"
      },
      {
        "name": "svg_icon_scene_is_05_svg",
        "source": "/svg/icon-scene/is-05.svg",
        "type": "svg"
      },
      {
        "name": "svg_icon_scene_is_06_svg",
        "source": "/svg/icon-scene/is-06.svg",
        "type": "svg"
      },
      {
        "name": "svg_icon_scene_is_07_svg",
        "source": "/svg/icon-scene/is-07.svg",
        "type": "svg"
      },
      {
        "name": "svg_icon_scene_is_08_svg",
        "source": "/svg/icon-scene/is-08.svg",
        "type": "svg"
      },
      {
        "name": "svg_uiframe_001_svg",
        "source": "/svg/uiframe/001.svg",
        "type": "svg"
      },
      {
        "name": "svg_uiframe_002_svg",
        "source": "/svg/uiframe/002.svg",
        "type": "svg"
      }
    ]
  },
  {
    "name": "thumbnails",
    "data": {},
    "items": [
      {
        "name": "thumbnails_blueverse_png",
        "source": "/thumbnails/blueverse.png",
        "type": "image"
      },
      {
        "name": "thumbnails_era_png",
        "source": "/thumbnails/era.png",
        "type": "image"
      },
      {
        "name": "thumbnails_omega_png",
        "source": "/thumbnails/omega.png",
        "type": "image"
      },
      {
        "name": "thumbnails_thegrid_png",
        "source": "/thumbnails/thegrid.png",
        "type": "image"
      }
    ]
  },
  {
    "name": "vid",
    "data": {},
    "items": [
      {
        "name": "vid_2_webm",
        "source": "/vid/2.webm",
        "type": "video"
      },
      {
        "name": "vid_eye_webm",
        "source": "/vid/eye.webm",
        "type": "video"
      },
      {
        "name": "vid_vantapoint_webm",
        "source": "/vid/vantapoint.webm",
        "type": "video"
      }
    ]
  }
];
